var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"view-public-notice"},[_c('div',{staticClass:"pb-detail"},[(_vm.publicNotice)?_c('comp-public-notice-viewer',{attrs:{"notice":_vm.publicNotice}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }